import { createFileRoute } from "@tanstack/react-router";
import { OverviewTab } from "./settings.subscription";

export const Route = createFileRoute("/settings/subscription/")({
	component: OverviewTab,
});
